// Load libraries needed to polyfill ES2015
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { createRoot } from 'react-dom/client';
// Load the stylesheets
import '../css/custom.less';
import App from './App';
import config from './services/config';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
dayjs.extend(customParseFormat);
dayjs.tz.setDefault(config.timezone);

const root = createRoot(document.getElementById('root') as HTMLElement);
root.render(<App />);
